module.exports = __webpack_public_path__ + "static/media/1-15.985b82a8.mp3";